import { Observable } from 'rxjs';

export interface Email {
  name: string;
  html?: any;
  img?: string;
  structure?: any;
  uid: string;
  id: string;
  timestamp?: number;
}


export abstract class EmailData {
  abstract createEmail(email: Email);
  abstract getEmails(pagination,filter,order);
  abstract getEmail(id: string);
  abstract editEmail(data: Email,id: string);
  abstract deleteEmail(id: string);
}
